const skillsData = [
  {
    category: "Languages",
    skills: [
      {
        tech: "Javascript",
        icon: "devicon-javascript-plain",
      },
      {
        tech: "Typescript",
        icon: "devicon-typescript-plain",
      },
      {
        tech: "C#",
        icon: "devicon-csharp-line",
      },
      {
        tech: "Python",
        icon: "devicon-python-plain",
      },
      {
        tech: "SQL",
        icon: "devicon-azuresqldatabase-plain"
      },
      {
        tech: "CSS",
        icon: "devicon-css3-plain",
      },
      {
        tech: "HTML",
        icon: "devicon-html5-plain",
      },
      {
        tech: "SASS",
        icon: "devicon-sass-original",
      },
      {
        tech: "Git",
        icon: "devicon-git-plain",
      },
    ],
  },
  {
    category: "Technologies",
    skills: [
      {
        tech: "React.js",
        icon: "devicon-react-original",
      },
      {
        tech: "Next.js",
        icon: "devicon-nextjs-plain",
      },
      {
        tech: "Redux",
        icon: "devicon-redux-original",
      },
      {
        tech: "Node.js",
        icon: "devicon-nodejs-plain",
      },
      {
        tech: "Jest",
        icon: "devicon-jest-plain"
      },
      {
        tech: "Pytest",
        icon: "devicon-pytest-plain"
      },
      {
        tech: "Django",
        icon: "devicon-django-plain",
      },
      {
        tech: "Express.js",
        icon: "devicon-express-original",
      },
      {
        tech: "AWS",
        icon: "devicon-amazonwebservices-plain-wordmark",
      },
      {
        tech: "Redis",
        icon: "devicon-redis-plain",
      },
      {
        tech: "Docker",
        icon: "devicon-docker-plain",
      },
      {
        tech: "Kubernetes",
        icon: "devicon-kubernetes-plain"
      },
      {
        tech: "Bootstrap",
        icon: "devicon-bootstrap-plain",
      },
    ],
  },
  {
    category: "Databases",
    skills: [
      {
        tech: "MySQL",
        icon: "devicon-mysql-plain",
      },
      {
        tech: "MongoDB",
        icon: "devicon-mongodb-plain",
      },
      {
        tech: "PostgreSQL",
        icon: "devicon-postgresql-plain",
      },
      {
        tech: "Firebase",
        icon: "devicon-firebase-plain",
      },
    ]
  }
];

export default skillsData;
